<template>
  <div>
    <template v-if="!showScanner">
      <div class="row mar-to-15">
        <div class="col-md-12 col-sm-12">
          <div class="card">
            <div class="card-content">
              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <div class="col-md-6 col-sm-6">
                    <div v-if="client" class="pull-left">
                      <img v-if="client.gender === 'F'" style="height: 141px; width: 141px;" src="/static/img/woman.svg" alt="Woman">
                      <img v-else src="/static/img/man.svg" style="height: 141px; width: 141px;" alt="Man">
                    </div>
                    <div class="mar-lt-15">
                      <div v-if="client"><h4>{{ client.name }}</h4></div>
                      <div v-if="client" class="email"><h5>{{ client.email }}</h5></div>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-4">
                    <div class="row">
                      <div v-if="client"><h2 class="mar-bt-0">{{ client.points }} pts.</h2></div>
                      <div v-if="client"><h2 class="mar-to-0"><small>({{ parseFloat(client.points_to_money).toFixed(2) }} {{ company.currency }})</small></h2></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="card">
            <div class="card-content">
              <div class="row">
                <div class="col-md-12 col-sm-12 flex-center">
                  <div class="points-input" name="minus-input">
                    <button @click="subtract()">-</button>
                    <div class="search">
                      <input class="points-input" type="number" v-model="points">
                    </div>
                    <button @click="increment()">+</button>
                  </div>
                </div>
              </div>
              <div class="row" v-if="parseInt(points)">
                <div class="col-md-12 col-sm-12 flex-center">
                  <small class="points-input points-to-money">{{ parseInt(points) / parseInt(company.loyalty_value_one_point_amount) }} {{ company.currency }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-sm-12 flex-center">
          <div class="confirm-button">
            <button class="confirm-button" @click="subtractPoints()">{{ $t('scanner.confirm') }}</button>
          </div>
        </div>
      </div>
    </template>

    <template v-if="showScanner">
      <div class="card flex-center mar-to-15">
        <div class="card-content">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <h4 class="mar-to-15">{{ $t('scanner.scanCode') }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="row flex-center" style="margin-top: 5%;">
        <div class="col-md-6 col-sm-12">
          <StreamBarcodeReader @decode="onDecodeQr" @loaded="onLoaded" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'
import { StreamBarcodeReader } from 'vue-barcode-reader'
Vue.component('StreamBarcodeReader', StreamBarcodeReader)

export default {
  data () {
    return {
      client: null,
      company: null,
      timestamp: null,
      client_id: null,
      showScanner: true,
      points: 1
    }
  },
  created () {
    if (!document.body.classList.contains('sidebar-mini')) {
      document.body.classList.toggle('sidebar-mini')
    }
  },
  mounted () {
    const style = document.createElement('style')
    style.id = 'scanner-swal-dynamic-style'
    style.textContent = `
      .swal2-popup, .swal2-title, .swal2-html-container, .swal2-content, .swal2-modal, swal2-buttonswrapper, button {
        font-size: 35px !important;
      }

      swal2-buttonswrapper, button {
        font-size: 30px !important;
      }
    `
    document.head.appendChild(style)
  },
  beforeDestroy () {
    const existing = document.getElementById('scanner-swal-dynamic-style')
    if (existing) {
      existing.remove()
    }
  },
  methods: {
    increment () {
      if (parseInt(this.points) + 5 <= this.client.points) {
        this.points += 5
      } else {
        this.points = this.client.points
      }
    },
    subtract () {
      this.points = Math.max(0, this.points - 5)
    },
    onLoaded () {},
    onDecodeQr (text) {
      this.getUser(text)
    },
    getUser (hash) {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        hash
      }
      this.apiRequest('/client-by-scanner', 'GET', data, (response) => {
        if (response.status === true) {
          this.showScanner = false
          this.client = response.data.client
          this.company = response.data.company
          this.points = this.client.points
        } else {
          swal({
            toast: true,
            type: 'warning',
            text: this.$t('scanner.' + response.error_code),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
        }
      })
    },
    subtractPoints () {
      const self = this
      let btnCounter = 3
      swal({
        text: `${self.$t('validations.subtractPoints')} ${this.points} ${self.$t('customers.points')} (${parseInt(this.points) / parseInt(this.company.loyalty_value_one_point_amount)} ${this.company.currency}) ?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: `${self.$t('general.yes')} (${btnCounter})`,
        cancelButtonText: self.$t('general.no'),
        customClass: 'scanner-swal-popup-lg scanner-swal-content-lg'
      }).then((result) => {
        if (result) {
          const data = {
            token: self.$session.get('token'),
            company_id: self.$session.get('selectedCompany'),
            hash: self.client.hash,
            points_spent: self.points
          }
          self.apiRequest('/subtract-loyalty-points', 'POST', data, (response) => {
            if (response.status) {
              self.reset()
              swal({
                toast: true,
                type: 'success',
                text: self.$t('general.success'),
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                customClass: 'scanner-swal-popup-lg scanner-swal-content-lg'
              })
            } else {
              if (response.error_code === 'expired') self.reset()
              swal({
                toast: true,
                type: 'warning',
                text: self.$t('scanner.' + response.error_code),
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                customClass: 'scanner-swal-popup-lg scanner-swal-content-lg'
              })
            }
          })
        }
      })
      swal.disableConfirmButton()
      const btnInterval = setInterval(() => {
        btnCounter--
        if (btnCounter >= 1) {
          swal.getConfirmButton().textContent = `${self.$t('general.yes')} (${btnCounter})`
        } else {
          swal.getConfirmButton().textContent = self.$t('general.yes')
          clearInterval(btnInterval)
          swal.enableConfirmButton()
        }
      }, 1000)
    },
    reset () {
      this.showScanner = true
      this.client = null
      this.company = null
    }
  }
}
</script>

<style lang="scss">
.points-input {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 65px !important;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: rgba(132, 132, 132, 0.49);
    border: 0;
    border-radius: 100%;
    width: 75px;
    height: 75px;
    font-size: 65px;
    background: #674BD2;
  }
}

.search {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 500px;

  input {
    width: 60%;
    height: 75px;
    padding-left: 25%;
    background: #F3F3F3;
    border-radius: 40px;
    border: 0;
    font-size: 16px;
  }
}

.confirm-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 80px;
  position: sticky;
  bottom: 0;
  height: 90px;

  button {
    padding: 20px 55px;
    background: #20C598;
    color: #fff;
    border: 0;
    border-radius: 10px;
    font-size: 45px;
  }
}

video {
  width: 100%;
}

.flex-center {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: center;
}
</style>

<style scoped>
/* @media (max-width: 1000px) {
  .points-input button {
    width: 75px;
    height: 75px;
    font-size: 55px;
  }

  .points-to-money {
    font-size: 25px;
  }

  .points-input {
    font-size: 40px;
  }

  .confirm-button {
    margin-top: 50px;
    font-size: 30px;
    padding: 10px 15%;
  }

  .search input {
    height: 80px;
    width: 75%;
    padding-left: 30%;
    font-size: 24px;
  }

  h4 {
    font-size: 2.5em;
  }
}

@media (max-width: 768px) {
  .points-input button {
    width: 90px;
    height: 90px;
    font-size: 65px;
  }

  .points-to-money {
    font-size: 30px;
  }

  .points-input {
    font-size: 50px;
  }

  .confirm-button {
    margin-top: 60px;
    font-size: 35px;
    padding: 15px 20%;
  }

  .search input {
    height: 90px;
    width: 85%;
    padding-left: 35%;
    font-size: 28px;
  }

  h4 {
    font-size: 3em;
  }
} */

.points-input {
  font-size: 45px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/LoyaltyPointsScanner/LoyaltyPointsScanner.vue